import KzasHandler from './KzasHandler'
import ApprovaFacilHandler from './ApprovaFacilHandler'

const Kzas = new KzasHandler()
const ApprovaFacil = new ApprovaFacilHandler()

Kzas.setNext(ApprovaFacil)

export default (listingData) => Kzas.handle(listingData)
